var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.49969 7.5L8.49969 0.5L7.5 0.500001L7.5 7.5L0.5 7.5L0.5 8.49969L7.5 8.49969L7.5 15.5H8.49969V8.49969H15.4999L15.5 7.5H8.49969Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }